import { ExpressionLogicalOperatorEnum, WhereClauseCompoundExpression } from "../ars_ldm";
import { isObjectRecord } from "./isObjectRecord";
import { isSubClause } from "./isSubClause";

/**
 * Type guard to check if a value is a WhereClauseCompoundExpression.
 *
 * Validates logical operator constraints:
 * - If logicalOperator is NOT, whereClauses must have 0 or 1 items
 * - If whereClauses has 2 or more items, logicalOperator must be AND or OR
 *
 * @param obj - The value to check
 * @returns True if the value is a WhereClauseCompoundExpression
 */
export const isWhereClauseCompoundExpression = (
  obj: unknown,
): obj is WhereClauseCompoundExpression => {
  // Check object
  if (!isObjectRecord(obj)) return false;
  // Check properties exist
  if (
    !Object.values(ExpressionLogicalOperatorEnum).includes(
      obj.logicalOperator as ExpressionLogicalOperatorEnum,
    )
  )
    return false;
  if (
    obj.whereClauses !== undefined &&
    (!Array.isArray(obj.whereClauses) || obj.whereClauses.some((item) => !isSubClause(item)))
  )
    return false;
  // Validate logical operator constraints
  const whereClausesCount = Array.isArray(obj.whereClauses) ? obj.whereClauses.length : 0;
  // If NOT, max 1 whereClause
  if (obj.logicalOperator === ExpressionLogicalOperatorEnum.NOT && whereClausesCount > 1)
    return false;
  // Everything is good
  return true;
};
